"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUrlParams = void 0;
const react_1 = require("react");
function useUrlParams() {
    const [params, setParams] = (0, react_1.useState)({
        brand: '',
        venue: '',
    });
    (0, react_1.useEffect)(() => {
        const path = window.location.pathname;
        const pathParts = path.split('/').filter(Boolean);
        if (pathParts.length >= 2) {
            setParams({
                brand: pathParts[0],
                venue: pathParts[1],
            });
        }
    }, []);
    return params;
}
exports.useUrlParams = useUrlParams;
